import React from 'react';
import PropTypes from 'prop-types';
import memoize from 'lodash/memoize';
import { fetchImgAsBase64 } from '@Utils/Network';
import { ButtonWithIcon } from '@els/els-react--button';
import ImageBase64 from '@Components/ImageBase64';
import StructureFilterSelectedOptionTitles from './StructureFilterSelectedOptionTitles';

const memorizedFetchImgAsBase64 = memoize(fetchImgAsBase64);

export default function StructureFilterPreview(props) {
  const { drawing, clearDrawn, drawOnClick } = props;
  const { preview } = drawing;

  return (
    <>
      <div className="structure-filter-preview-wrapper">
        <ButtonWithIcon
          data-e2e="delete-structure"
          type="link"
          size="small"
          linkIconSize="xs"
          sprite="Close"
          iconOnly
          onClick={clearDrawn}
          className="structure-filter-close-wrapper e2e-delete-structure">
          Delete structure
        </ButtonWithIcon>

        <ImageBase64 src={preview} getImageAsync={memorizedFetchImgAsBase64}>
          {({ src }) => {
            if (!src) {
              return null;
            }

            return <img alt="Structure Preview" src={src} className="structure-filter-preview" />;
          }}
        </ImageBase64>

        <ButtonWithIcon
          data-e2e="edit-structure"
          type="link"
          size="small"
          linkIconSize="s"
          sprite="Edit"
          iconOnly
          onClick={drawOnClick}
          className="structure-filter-edit-wrapper e2e-edit-structure">
          Edit structure
        </ButtonWithIcon>
      </div>
      <StructureFilterSelectedOptionTitles {...props} />
    </>
  );
}

StructureFilterPreview.propTypes = {
  drawing: PropTypes.shape({
    preview: PropTypes.string.isRequired,
  }),
  clearDrawn: PropTypes.func.isRequired,
  drawOnClick: PropTypes.func.isRequired,
  optionsButtonOnClick: PropTypes.func.isRequired,
};
